'use client';

import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';
import type { PropsWithChildren } from 'react';

const ProgressBarProvider = ({ children }: PropsWithChildren) => {
  return (
    <>
      {children}
      <ProgressBar
        height="4px"
        color="#e4003a"
        options={{ showSpinner: true }}
        shallowRouting
      />
    </>
  );
};

export default ProgressBarProvider;
